
/**
 * Extracts the filename from the Content-Disposition header.
 * Supports filename*, quoted filename, and unquoted filename.
 * @param {string} header - The Content-Disposition header value.
 * @returns {string|null} - The extracted filename or null if not found.
 */
export const extractFilenameFromHeader = (header) => {
    if (!header) return null;

    // 1. Try filename* (RFC 5987)
    const filenameStar = header.match(/filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i);
    if (filenameStar && filenameStar[1]) {
        return decodeURIComponent(filenameStar[1]);
    }

    // 2. Try quoted filename
    const filenameQuoted = header.match(/filename="([^"]+)"/i);
    if (filenameQuoted && filenameQuoted[1]) {
        return filenameQuoted[1];
    }

    // 3. Try unquoted filename
    const filenameUnquoted = header.match(/filename=([^;]+)/i);
    if (filenameUnquoted && filenameUnquoted[1]) {
        return filenameUnquoted[1].trim();
    }

    return null;
};
